import { createRealtime } from "@upstash/realtime/client";
import type { RealtimeEvents } from "#/utils/realtime";

export const { useRealtime } = createRealtime<RealtimeEvents>();
